import { render, staticRenderFns } from "./SingleUser.vue?vue&type=template&id=e2eb0252&scoped=true&"
import script from "./SingleUser.vue?vue&type=script&lang=js&"
export * from "./SingleUser.vue?vue&type=script&lang=js&"
import style0 from "./SingleUser.css?vue&type=style&index=0&id=e2eb0252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eb0252",
  null
  
)

export default component.exports